import React from "react";
import {Redirect} from 'react-router';
import {NavLink} from 'react-router-dom';

import Button from "components/CustomButtons/Button.jsx";
import Icon from '@material-ui/core/Icon';
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import TagsInput from 'react-tagsinput'
import 'react-tagsinput/react-tagsinput.css'
import ReactTable from "react-table";
import "react-table/react-table.css";
import matchSorter from 'match-sorter';
import Loader from "../Loader/index";
import api from "../../api/Api";
import {mappingUI, dashboardRouter} from '../../util/globalHelper';
import Permissions from '../../util/globalPermissions';
class oneDoctor extends React.Component {

    constructor(props) {

        super(props);
        this.state = {
            doctor_id: "",
            data: null,
            notFound: null,
            clinic_data: [],
            clickedId: "",
            redirect: false,
            alert: null,
            api_url: "",
            redirectAll: false,
            open: true
        };

    }

    RouteToUpdate = (clickedID) => (e) => {
        this.setState({clickedId: clickedID});
        this.setState({redirect: true});
    };

    hideDeleteAlert = () => {
        this.setState({
            alert: null
        });
    }

    componentDidMount() {
        this.CallReadApi(this.props.id.match.params.doctorID);
        this.setState({clickedId: this.props.id.match.params.doctorID})
    }

    CallReadApi = (id,) => {
        api.getDoctorById(id).then(json => {
            this.setState({data: json.data.data})
        }).catch(error => {
            this.setState({notFound: error})
        });
    }

    DeleteAlert = (param1, param2) => (e) => {
        this.setState({
            alert: (
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">Are you sure you want to Delete?</DialogTitle>

                    <DialogActions>
                        <Button onClick={this.hideDeleteAlert}>
                            Disagree
                        </Button>
                        <Button onClick={this.CallApi} color="danger" autoFocus>
                            Agree
                        </Button>
                    </DialogActions>
                </Dialog>
            ),
            selectedId: param2
        });
    }

    CallApi = () => {
        api.deleteDoctorById(this.state.selectedDoctorId)
            .then(json => {
                this.setState({alert: null, redirectAll: true});
            })

    }

    render() {
        const {data} = this.state;
        const {classes} = this.props;
        const data1 = this.state.data;
        if (this.state.data !== null) {
            return (
                <div>
                    <Card>
                        <CardHeader>
                            <h2>{data.user_details ? "Dr " + data.user_details.name : "No Name"}</h2>
                        </CardHeader>
                        <CardBody>
                            <GridContainer>
                                <GridItem xs={12} md={8}>
                                    <GridContainer>
                                        <GridItem md={12}>
                                            <TagsInput tagProps={{className: "react-tagsinput-tag info"}}
                                                       value={data1.doctor_speciality.map(function (obj) {
                                                           return obj.speciality
                                                       })} disabled
                                                       onChange={this.handleChange} inputProps={{placeholder: ""}}/>
                                        </GridItem>

                                        <GridItem md={12}>
                                            <p>{data.doctor_description ? data.doctor_description[0] === "<" ?
                                                <div
                                                    dangerouslySetInnerHTML={{__html: data.doctor_description}}/> : data.doctor_description : null}
                                            </p>
                                            {/*<p>{data.doctor_description}</p>*/}
                                        </GridItem>

                                        <GridItem md={6}>

                                            <GridItem>
                                                <p><b>{data.doctor_qualification}</b></p>
                                                <p>Qualification</p>
                                            </GridItem>

                                            {data.doctor_experience ?
                                                <GridItem>
                                                    <p><b>{data.doctor_experience} years</b></p>

                                                    <p>Experience</p>
                                                </GridItem> : null}

                                            {data.user_details.gender ?
                                                <GridItem>
                                                    <p><b>{data.user_details.gender}</b></p>
                                                    <p>Gender</p>
                                                </GridItem> : null}

                                        </GridItem>

                                        <GridItem md={6}>
                                            <GridItem>
                                                <p><b>{data.user_details.contact}</b></p>
                                                <p>Contact</p>
                                            </GridItem>

                                            <GridItem>
                                                <p><b>{data.user_details.email}</b></p>
                                                <p>Email</p>
                                            </GridItem>
                                            {data.doctor_MCI_Number ?
                                                <GridItem>
                                                    <p><b>{data.doctor_MCI_Number}</b></p>

                                                    <p>MCI Number</p>
                                                </GridItem> : null}
                                        </GridItem>
                                    </GridContainer>
                                </GridItem>
                                <GridItem md={2}>
                                    <GridItem>
                                        <img
                                            data-src="holder.js/100px180/"
                                            alt="Doctor"
                                            style={{display: "block", maxWidth: 200, maxHeight: "auto"}}
                                            src={data1.user_details
                                                ? data1.user_details.profile_image
                                                : ''}
                                            data-holder-rendered="true"
                                            onError={(e) => {
                                                e.onerror = null;
                                                e.target.src = require('assets/img/placeholder.jpg')
                                            }}
                                        />
                                    </GridItem>
                                    <GridItem>
                                        { mappingUI(Permissions.UpdateDoctor) ?  <NavLink
                                            to={dashboardRouter(`/doctor/updateDoctorDetails/${data.doctor_id}`)}>
                                            <Button block color="warning">
                                                <Icon>border_color</Icon>
                                                <span style={{paddingLeft: 10}}>Update</span>
                                            </Button>
                                        </NavLink>:null}
                                        <br></br>
                                        {/*<Button color="danger"*/}
                                        {/*onClick={this.DeleteAlert('Delete', data1.doctor_id)}*/}
                                        {/*>*/}
                                        {/*<Icon>delete</Icon>Delete</Button>*/}
                                    </GridItem>
                                </GridItem>
                            </GridContainer>


                            <div>
                                <h3><b>My Clinics</b></h3>
                                {this.state.alert}
                                {data.doctor_clinics ?
                                    <ReactTable
                                        data={data.doctor_clinics}
                                        filterable

                                        defaultFilterMethod={(filter, row) =>
                                        String(row[filter.id]) === filter.value}
                                        columns={[
                                            {
                                                columns: [
                                                    {
                                                        Header: "Clinic Name",
                                                        id: "clinic_id.name",
                                                        accessor: "clinic_id.name",
                                                        filterMethod: (filter, rows) =>
                                                            matchSorter(rows, filter.value, {keys: ["clinic_id.name"]}),
                                                        filterAll: true
                                                    },
                                                    {
                                                        Header: "Timings",
                                                        id: "timings",
                                                        accessor: "timings",
                                                        Cell: ({index}) =>
                                                            (<div>
                                                                    {data.doctor_clinics && data.doctor_clinics[index].timings ? data.doctor_clinics[index].timings.map(function (station) {
                                                                        return <div key={Math.random()}>
                                                                            <b> {station.day === "mon" ? "Monday" : station.day === "tues" ? "Tuesday" :
                                                                                station.day === "wednes" ? "Wednesday" : station.day === "thurs" ? "Thursday" : station.day === "fri" ? "Friday" :
                                                                                    station.day === "satur" ? "Saturday" : station.day === "sun" ? "Sunday" : "Undefined"
                                                                            }: </b> {station.open_time !== "" ? station.open_time + "-" + station.close_time : "Closed"}
                                                                        </div>
                                                                    }) : null}
                                                                </div>
                                                            ),
                                                        filterMethod: (filter, rows) =>
                                                            matchSorter(rows, filter.value, {keys: ["timings"]}),
                                                        filterable: false,
                                                        sortable: false
                                                    },
                                                    {
                                                        Header: "Services",
                                                        accessor: "services",
                                                        filterMethod: (filter, rows) =>
                                                            matchSorter(rows, filter.value, {keys: ["services"]}),
                                                        Cell: ({index}) =>
                                                            (<GridContainer>
                                                                    <GridItem>

                                                                        {data.doctor_clinics && data.doctor_clinics[index].services.length > 0 ? data.doctor_clinics[index].services.map(function (station) {
                                                                            return <div key={Math.random()}>
                                                                                {<b>{station.service}</b>}</div>
                                                                        }) : "No Services"}
                                                                    </GridItem>
                                                                </GridContainer>
                                                            ),
                                                        filterable: false,
                                                        sortable: false
                                                    },
                                                    {
                                                        Header: 'Actions',
                                                        id: 'request_state',
                                                        filterable: false,
                                                        sortable: false,
                                                        Cell: ({index}) =>
                                                            (<div>
                                                                    <NavLink
                                                                        to={data.doctor_clinics[index] && data.doctor_clinics[index].clinic_id ? dashboardRouter(`/clinic/oneClinic/${data.doctor_clinics[index].clinic_id._id}`) : `/`}>
                                                                        <Button type="button" color="info"
                                                                                style={{padding: 5, left: 0}}
                                                                        >
                                                                            <Icon style={{fontSize: 22}}>info</Icon>
                                                                        </Button></NavLink>
                                                                    <NavLink
                                                                        to={data.doctor_clinics[index] && data.doctor_clinics[index].clinic_id ? dashboardRouter(`/doctor/updateDoctorDetails/${data.doctor_id}/${data.doctor_clinics[index].clinic_id._id}`) : "/"}><Button
                                                                        type="button" color="success"
                                                                        style={{padding: 5, left: 20}}>
                                                                        <Icon style={{fontSize: 22}}>edit</Icon>
                                                                    </Button></NavLink>
                                                                    {/*<Button type="button" color="danger"*/}
                                                                    {/*style={{padding: 3, left: 40}}*/}
                                                                    {/*onClick={this.DeleteAlert('Delete', data[index].clinic_id)}*/}
                                                                    {/*>*/}
                                                                    {/*<Icon style={{fontSize: 22}}>close</Icon>*/}
                                                                    {/*</Button>*/}
                                                                </div>
                                                            )
                                                    }
                                                ]
                                            }
                                        ]}
                                        defaultPageSize={5}
                                        className="-striped -highlight"
                                    /> : null}
                            </div>

                        </CardBody>
                    </Card>
                </div>
            );
        }
        else if (this.state.notFound !== null) {
            return <h2 className="text-center">Data Not Found</h2>
        }
        else return (<div>
                <Loader/></div>)
    }
}

export default (oneDoctor);



// WEBPACK FOOTER //
// ./src/components/Doctor/oneDoctor.jsx